export default __webpack_public_path__ + "static/NuvemFiscalCNPJ-0c0bd311ebe71b621835ff4b57404da6.png";